import getUrlForEnv, { services } from "@irati/utils/endpoints/getUrlForEnv";
var endpoints = {
    drivers: function () { return getUrlForEnv(services.INSIGHTS_QUESTION_SERVICE, "/v1/drivers"); },
    driver: function (uuid) { return getUrlForEnv(services.INSIGHTS_QUESTION_SERVICE, "/v1/drivers/" + uuid); },
    questions: function () { return getUrlForEnv(services.INSIGHTS_QUESTION_SERVICE, "/v1/questions"); },
    question: function (uuid) { return getUrlForEnv(services.INSIGHTS_QUESTION_SERVICE, "/v1/questions/" + uuid); },
    questionsOverrides: function (tenantUuid) {
        return getUrlForEnv(services.INSIGHTS_QUESTION_SERVICE, "/v1/questions/overrides/" + tenantUuid);
    },
    updateQuestionsOverrides: function (uuid, tenantUuid) {
        return getUrlForEnv(services.INSIGHTS_QUESTION_SERVICE, "/v1/questions/" + uuid + "/override/" + tenantUuid);
    },
    userSurvey: function (tenant, id) { return getUrlForEnv(services.INSIGHTS_SURVEYS_SERVICE, "/v1/" + tenant + "/userSurveys/" + id); },
    userSurveys: function (tenant) { return getUrlForEnv(services.INSIGHTS_SURVEYS_SERVICE, "/v1/" + tenant + "/userSurveys"); },
    survey: function (tenant, id) { return getUrlForEnv(services.INSIGHTS_SURVEYS_SERVICE, "/v1/" + tenant + "/surveys/" + id); },
    surveys: function (tenant) { return getUrlForEnv(services.INSIGHTS_SURVEYS_SERVICE, "/v1/" + tenant + "/surveys"); },
    surveyInfo: function (tenant, id) { return getUrlForEnv(services.INSIGHTS_SURVEYS_SERVICE, "/v1/" + tenant + "/surveys/" + id + "/info"); },
    schedule: function (tenant, id) { return getUrlForEnv(services.INSIGHTS_SURVEYS_SERVICE, "/v1/" + tenant + "/schedules/" + id); },
    schedules: function (tenant) { return getUrlForEnv(services.INSIGHTS_SURVEYS_SERVICE, "/v1/" + tenant + "/schedules"); },
    commentsUserSurvey: function (tenant, id) {
        return getUrlForEnv(services.INSIGHTS_SURVEYS_SERVICE, "/v1/" + tenant + "/comments/userSurvey/" + id);
    }
};
export default endpoints;
